
export default{
  // UUID就是Universal Unique IDentifier的缩写，它是一个128位，16字节的值，并确保在时间和空间上唯一。
  // 它是把硬件地址、时间以及随机数结合在一起，它保证对在同一时空中的所有机器都是唯一的。
  // 这个可以指定长度和基数
  uuid (len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = []
    var i
    radix = radix || chars.length
    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
      // rfc4122, version 4 form
      var r
      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16
          uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
        }
      }
    }
    return uuid.join('')
  },
  arr2str (arr, divider) {
    let r = ''
    divider = divider || ','
    for (let i = 0; i < arr.length; i++) {
      r += arr[i] + divider
    }
    r = (r.substring(r.length - 1) === divider)  ? r.substring(0, r.length - 1) : r
    return r
  },
  findStrPos (str, cha, num) {
    var x = str.indexOf(cha);
    for (var i = 0; i < num; i++) {
      x = str.indexOf(cha, x + 1);
    }
    return x;
  },
  findElem (arrayToSearch, attr, val) { /* 按照属性值，查找对象 */
    for (var i=0; i<arrayToSearch.length; i++) {
      if (arguments.length >=3) {
        if (arrayToSearch[i]) {
          if (arrayToSearch[i][attr] == val) {
            return i;
          }
        }
      } else { // 普通数组
        if (arrayToSearch[i] == arguments[1]) {
          return i;
        }
      }
    }
    return -1;
  },
  removeObjWithArr (_arr, _obj) {
    var length = _arr.length;
    for (var i = 0; i < length; i++) {
      if (_arr[i] == _obj) {
        if (i == 0) {
          _arr.shift(); // 删除并返回数组的第一个元素
          return;
        } else if (i == length-1) {
          _arr.pop();  // 删除并返回数组的最后一个元素
          return;
        } else {
          _arr.splice(i, 1); // 删除下标为i的元素
          return;
        }
      }
    }
  },
  isEmptyObj (obj) {
    return JSON.stringify(obj) == "{}"
  },
  transformDateStr (date) {
    return new Date(date).getTime()
  },
  substring (str, start, end) {
    return str.substring(start, end)
  },
  URLencode (str) {
    return escape(str).replace(/\+/g, '%2B').replace(/"/g, '%22').replace(/'/g, '%27').replace(/\//g, '%2F');
  },
  dateFormat (date, fmt) {
    function dateFtt (date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        "S": date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return fmt;
    }
    return dateFtt(date, fmt);
  },
  formatSeconds (value) {
    let secondTime = parseInt(value);// 秒
    let minuteTime = 0;// 分
    let hourTime = 0;// 小时
    if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
      // 获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60);
      // 获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60);
      // 如果分钟大于60，将分钟转换成小时
      if (minuteTime > 60) {
        // 获取小时，获取分钟除以60，得到整数小时
        hourTime = parseInt(minuteTime / 60);
        // 获取小时后取佘的分，获取分钟除以60取佘的分
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    let result = "" + parseInt(secondTime) + "秒";

    if (minuteTime > 0) {
      result = "" + parseInt(minuteTime) + "分" + result;
    }
    if (hourTime > 0) {
      result = "" + parseInt(hourTime) + "小时" + result;
    }
    return result;
  },
  invoiceDateFormat (str) {
    let r
    if (!str) {
      r = ''
    } else {
      let year = str.substring(0, 4)
      let month = str.substring(4,6)
      let date = str.substring(6,8)
      let hour = str.substring(8, 10)
      let min = str.substring(10, 12)
      let sec = str.substring(12, 14)
      r = year + '-' + month + '-' + date + ' ' + hour + ':' + min + ':' + sec
    }
    return r
  },
  dateInRange (stime, etime) {
    /* 检查当前日期是否在某个时间段内
      dateInRange('2016-8-1','2016-8-10'); //注意：日期用“-”分隔
    */
    //开始时间
    var arrs = stime.split("-");
    var startTime = new Date(arrs[0], arrs[1], arrs[2]);
    var startTimes = startTime.getTime();
    //结束时间
    var arre = etime.split("-");
    var endTime = new Date(arre[0], arre[1], arre[2]);
    var endTimes = endTime.getTime();
    //当前时间
    var thisDate = new Date();
    var thisDates = thisDate.getFullYear() + "-0" + (thisDate.getMonth() + 1) + "-" + thisDate.getDate();
    var arrn = thisDates.split("-");
    var nowTime = new Date(arrn[0], arrn[1], arrn[2]);
    var nowTimes = nowTime.getTime();
    if (nowTimes < startTimes || nowTimes > endTimes) {
      if (nowTimes < startTimes) {
        return {
          inRange: false,
          msg: '尚未开始'
        }
      } else {
        return {
          inRange: false,
          msg: '已经结束'
        }
      }
    }
    return { inRange: true }
  },
  randomNum (minNum, maxNum) {
    switch (arguments.length) {
      case 1:
        return parseInt(Math.random()*minNum+1, 10);
      case 2:
        return parseInt(Math.random()*(maxNum-minNum+1)+minNum, 10);
      default:
        return 0;
    }
  },
  copyArray (arr) { // 深复制数组
    return arr.map((e) => {
      if (typeof e ==='object') {
        return Object.assign({}, e);
      } else {
        return e;
      }
    })
  },
  deepCopy (obj, copy) { // 深复制对象
    for (var i in obj) {
      if (typeof obj[i] == 'object') { // 判断是否为对象
        this.deepCopy(obj[i], copy[i]); // 回调深拷贝函数
      } else {
        copy[i] = obj[i]; // 不是对象直接复制
      }
    }
    return copy;
  },
  iteration (data, callback) {
    for (var j = 0; j < data.length; j++) {
      if (callback) {
        callback(data[j])
      }
      if (data[j].children != undefined && data[j].children.length > 0) {
        this.iteration(data[j].children, callback)
      }
    }
  },
  /* flattern (data, keys, level = 0) {
    return data.reduce((arr, x) => [
      ...arr,
      keys.reduce((o, k) => (o[k] = x[k], o), {level}),
      ...this.flattern(x.children || [], keys, level + 1),
    ], [])
  }, */
  flattern (arr) {
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].children) {
        // 如果是数组，调用(递归)将其扁平化
        // 然后再 push 到 newArr 中
        newArr = newArr.concat(this.flattern(arr[i].children))
        newArr.push(arr[i])
      } else {
        // 不是数组直接 push 到 newArr 中
        newArr = newArr.concat(arr[i]);
      }
    }
    return newArr;
  },
  grabVal (arr, key) {
    var r = []
    for (let i = 0; i < arr.length; i++) {
      r.push(arr[i][key])
    }
    return r
  },
  setVal (arr, key, val) {
    var r = []
    for (let i = 0; i < arr.length; i++) {
      arr[i][key] = val
    }
    return r
  },
  /* 显示隐藏 */
  fadeIn (show) {
    $(show).fadeIn()
  },
  fadeOut (hide) {
    $(hide).fadeOut()
  },
  bracketText (str) {
    var matchStr=str;
    var resultArray=[];
    var bracket = /\((.*?)\)/;// 要计算的字符*!/
    var regex = new RegExp(bracket, 'igm'); // 使用g表示整个字符串都要匹配
    var result = matchStr.match(regex);
    var count = !result ? 0 : result.length;
    for (let i=0; i<count; i++) {
      result[i]=result[i].replace("(", "");
      result[i]=result[i].replace(")", "");
      result[i]=result[i].replace(/(^\s*)|(\s*$)/g, "");
      resultArray.push(result[i]);
    }
    return resultArray;
  },
  bracketReplace (str, replaceInput) {
    var bracketNum;
    var matchStr=str;
    var bracket = /\((.+?)\)/;// 要计算的字符*!/
    var regex = new RegExp(bracket, 'igm'); // 使用g表示整个字符串都要匹配
    var result = matchStr.match(regex);
    bracketNum = !result ? 0 : result.length;
    var wtStr=matchStr.replace(regex, replaceInput);
    return wtStr;
  },
  getCurrentStrWidth (text, font) {
    var currentObj = $('<span>').hide().appendTo(document.body);
    $(currentObj).html(text).css('font', font);
    var width = currentObj.width();
    currentObj.remove();
    return width;
  },
  /* 字符串转dom对象 */
  parseDom (arg) {
    var objE = document.createElement("div");
    objE.innerHTML = arg;
    return objE;
  },
  debounce (fn, delay) { // 将会包装事件的 debounce 函数
    let timer = null;
    return function () {
      // 通过 ‘this’ 和 ‘arguments’ 获取函数的作用域和变量
      let context = this;
      let args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    }
  },
  getQueryString (variable) { // 获取地址栏url
    var query = window.location.href.split('?')[1];
    if (query) {
      var vars = query.split("&");
      for (var i=0; i<vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
    }
    return false;
  },
  delQueryString (url, ref) {
  var str = "";
  if (url.indexOf('?') != -1) {
    str = url.substr(url.indexOf('?') + 1);
  } else {
    return url;
  }
  var arr = "";
  var returnurl = "";
  var setparam = "";
  if (str.indexOf('&') != -1) {
    arr = str.split('&');
    for (let i in arr) {
      if (arr[i].split('=')[0] != ref) {
        returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
      }
    }
    return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
  } else {
    arr = str.split('=');
    if (arr[0] == ref) {
      return url.substr(0, url.indexOf('?'));
    } else {
      return url;
    }
  }
},
  judgementOri (orgType) {
    if (orgType == '1') { // 职称教育
      return 'continueEdu'
    } else if (orgType == '2') { // 安全教育
      return 'byl'
    } else if (orgType == '3') { // 企业内训
      return 'entrain'
    } else if (orgType == '4') { // 党建教育
      return 'byl'
    } else {
      return 'byl'
    }
  },
  judgmentState (startDate, endDate) {
    let S_timestamp = new Date(startDate).getTime()
    let E_timestamp = new Date(endDate).getTime()
    let C_timestamp = new Date().getTime()
    if (S_timestamp<=E_timestamp) {
      if (C_timestamp >= S_timestamp && C_timestamp <= E_timestamp) {
        return '0'  // 进行中
      } else if (C_timestamp > E_timestamp) {
        return '1'  // 已结束
      } else if (C_timestamp < S_timestamp) {
        return '2'  // 未开始
      }
    } else {
      return '-1' // 时间有误
    }
  },
  floatAdd () {
    var args = arguments //获取所有的参数
    var lens = args.length//获取参数的长度
    var d = 0 //定义小数位的初始长度，默认为整数，即小数位为0
    var sum = 0  //定义sum来接收所有数据的和
    //循环所有的参数
    for(var key in args) {//遍历所有的参数
      //把数字转为字符串
      var str = ""+args[key];
      if(str.indexOf(".")!=-1){//判断数字是否为小数
        //获取小数位的长度
        var temp = str.split(".")[1].length;
        //比较此数的小数位与原小数位的长度，取小数位较长的存储到d中
        d = d < temp ? temp : d;
      }
    }
    //计算需要乘的数值
    var m = Math.pow(10,d);
    //遍历所有参数并相加
    for(var key in args){
      sum += args[key]*m;
    }
    //返回结果
    return sum/m;
  },
  isIP (ip) {
    var re=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; // 正则表达式
    if (re.test(ip)) {
      if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256) {
        return true;
      }
    }
    return false;
  },
  sortNumber (a, b) {
    return a-b;
  },
  sortByKey (array, key) {
    return array.sort(function (a, b) {
      var x=a[key];
      var y=b[key];
      return ((x<y)?-1:((x>y)?1:0));
    });
  },
  handleXss (s) {
    var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
    var rs = "";
    for (var i = 0; i < s.length; i++) {
      rs = rs+s.substr(i, 1).replace(pattern, '');
    }
    return rs;
  },
  trimSpace (str, is_global) {
    var result;
    result = str.replace(/(^\s+)|(\s+$)/g, "");
    if (is_global) {
      result = result.replace(/\s/g, "");
    }
    return result;
  },
  trimTail (str, divider) {
    return (str.substring(str.length - 1) === divider) ? str.substring(0, str.length - 1) : str
  },
  dealQInfoNull (para) {
    if (!para || para== 'undefined' || para == '') {
      para = ''
      return para
    } else {
      return para
    }
  },
  deepQuery (data, targetVal, key) {
    var stark = [];
    stark = stark.concat(data);
    while (stark.length) {
      var temp = stark.shift();
      if (temp.children) {
        stark = temp.children.concat(stark);
      }
      if (targetVal === temp[key]) {
        return temp;
      }
    }
  },
  slasher(arr, howMany) {
    var arr1 = new Array();
    if(arr.length == howMany){
      return arr1;
    }else{
      arr1 = arr.splice(0,howMany);
    }
    return arr1;
  },
  isObject (val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
  },
  isArray(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  },
  isAbsolutePath (url) {
    return url.substr(0,7).toLowerCase() == "http://" || url.substr(0,8).toLowerCase() == "https://"
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js